import {
  Collapse,
  Comment,
  Descriptions,
  Spin,
  Table,
  Modal,
  Input,
  Button,
  Affix,
  Radio,
  Form,
} from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Report } from "notiflix";

import "../styles.css";
import Footer from "../../../atoms/footer";
import Navbar from "../../../atoms/navbar";

import { requestToken } from "../../../auth/AuthServices";
import ImportantInfo from "../../../atoms/important-updates";
import { useIsAuthenticated } from "@azure/msal-react";

import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";
import moment from "moment";

const ViewEpicorPR = () => {

  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  let { id } = useParams();

  const { Panel } = Collapse;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [loading, setLoading] = useState(true);

  const [PR, setPR] = useState(null);

  const getViewPR = (token) => {

    const epicorToken = localStorage.getItem("epicor_token");

    if (!epicorToken) return navigate("/epicor/pending");

    const headers = HeaderFarms(token);
    const fullHeaders = { ...headers, token: epicorToken };

    API.GetEpicorViewPR(fullHeaders, id)

      .then((res) => {

        const data = res;

        if (res?.data?.length === 0) return navigate("/epicor/pending");

        setPR(data);
        setLoading(false);

      })
      .catch((err) => {
        if (
          err?.response?.status === 401 &&
          err?.response?.data?.error === "Invalid or expired token"
        ) {
          console.warn("Token expired atau tidak valid");
          localStorage.removeItem("epicor_token");
          navigate("/epicor/pending");
        } else {
          console.error(err);
          Report.warning(
            "Oops.. something wrong",
            "Sorry, this application is experiencing problems",
            "Okay"
          );
        }
      });
  };

  const getTotalDocExtCost = () => {
    if (!PR?.details?.value) return 0;
    return PR.details.value.reduce((total, item) => {
      const cost = Number(item.DocExtCost);
      return total + (isNaN(cost) ? 0 : cost);
    }, 0);
  };

  const showModal = () => {
    setIsModalVisible(true);
    form.resetFields();
    form.setFieldsValue({
      username:
        JSON.parse(localStorage.getItem("session_farms"))?.employee_id || "",
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  function parseJwt(token) {
    const base64Url = token.split(".")[1]; // ambil payload
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        setConfirmLoading(true);
        const accessToken = await requestToken();
        const epicorToken = localStorage.getItem("epicor_token");
        const resultsEncodeToken = parseJwt(
          localStorage.getItem("epicor_token")
        );

        const headers = HeaderFarms(accessToken);
        const fullHeaders = { ...headers, token: epicorToken };

        const epicorEmp_id = resultsEncodeToken.username || values.username;
        try {
          if (values.approvalDecision === "approve") {
            await API.EpicorApprovePR(fullHeaders, id, {
              username: epicorEmp_id,
              nextNote: values.nextNote,
            });
          } else {
            await API.EpicorRejectPR(fullHeaders, id, {
              username: epicorEmp_id,
              nextNote: values.nextNote,
            });
          }

          Report.success(
            values.approvalDecision === "approve" ? "Approved" : "Rejected",
            `PR berhasil ${values.approvalDecision === "approve" ? "disetujui" : "ditolak"
            }`,
            "OK"
          );
          setIsModalVisible(false);

          return navigate("/epicor/pending");
        } catch (error) {
          if (error.response) {
            const status = error.response.status;
            let message = "An error occurred. Please try again..";

            if (status === 404) {
              message =
                "Data not found, maybe process in purchasing department.";
            } else if (status === 401) {
              message = "Password Invalid.";
            } else if (status === 429) {
              message =
                "Too many attempts. Please wait 15 minutes to try again.";
            } else {
              message = `Request failed ${status}.`;
            }

            // Reset hanya field password
            form.resetFields(["password"]);

            // Setelah reset, kasih waktu 1 tick baru set error biar muncul
            setTimeout(() => {
              form.setFields([
                {
                  name: "password",
                  errors: [message],
                },
              ]);

              // Auto-focus biar UX-nya enak
              document.querySelector("input[name='password']")?.focus();
            }, 0);
          }
        } finally {
          setConfirmLoading(false);
        }
      })
      .catch(() => { });
  };

  const columnPRDetail = [
    {
      title: "Part Number",
      dataIndex: "PartNum",
      key: "PartNum",
    },
    {
      title: "Line Description",
      dataIndex: "LineDesc",
      key: "LineDesc",
    },
    {
      title: "Class",
      dataIndex: "Class",
      key: "Class",
    },
    {
      title: "Project Detail Description",
      dataIndex: "ProjectDtlDesc_c",
      key: "ProjectDtlDesc_c",
    },
    {
      title: "WBS Phase Detail Description",
      dataIndex: "WBSPhaseDtlDesc_c",
      key: "WBSPhaseDtlDesc_c",
    },
    {
      title: "GL Account",
      dataIndex: "GLAccount_c",
      key: "GLAccount_c",
    },
    {
      title: "Account Description",
      dataIndex: "AccountDesc_c",
      key: "AccountDesc_c",
    },
    {
      title: "Priority",
      dataIndex: "Priority_c",
      key: "Priority_c",
    },
    {
      title: "Order Quantity",
      dataIndex: "OrderQty",
      key: "OrderQty",
      render: (value) => (value != null ? Math.round(value) : "-"),
    },
    {
      title: "RUM",
      dataIndex: "RUM",
      key: "RUM",
    },
    {
      title: "Document Extended Cost",
      dataIndex: "DocExtCost",
      key: "DocExtCost",
      render: (value) =>
        value != null ? `${Math.round(value).toLocaleString("id-ID")}` : "-",
    },
    {
      title: "Currency Code",
      dataIndex: "CurrencyCode",
      key: "CurrencyCode",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = await requestToken();

        if (!accessToken) {
          
          return;
        }

        getViewPR(accessToken);
      } catch (error) {
        console.error("❌ Gagal mengambil data:", error);
      }
    };

    fetchData();
  }, [isAuthenticated]);
  return (
    <>
      <Navbar
        title="View"
        back={true}
        subtitle="View PR"
        navigate="/epicor/pending"
      ></Navbar>
      <div className="container-fluid white-back-cr">
        <ImportantInfo></ImportantInfo>
        <div className="container mt-3 p-0" style={{ alignSelf: "center" }}>
          <div className="row mt-1">
            {loading && (
              <div
                className="fs-6 text-center mt-5"
                style={{ color: "#B7B7B7" }}
              >
                <Spin size="large" />
              </div>
            )}
            {PR && (
              <>
                <div className="col-md-12 col-24 mb-2">
                  <Collapse defaultActiveKey={["1"]}>
                    <Panel header={<div>Detail Information</div>} key="1">
                      {PR ? (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 col-24">
                              {PR && (
                                <Descriptions
                                  size="small"
                                  bordered
                                  title="Information"
                                  className="mb-1"
                                >
                                  <Descriptions.Item
                                    label={PR.ReqType_c + " Number"}
                                  >
                                    {PR.ReqNum}
                                  </Descriptions.Item>
                                  <Descriptions.Item
                                    className="col-md-3 col-24"
                                    label="Type"
                                  >
                                    {PR.ReqType_c}
                                  </Descriptions.Item>
                                </Descriptions>
                              )}
                            </div>
                            <div className="col-md-12">
                              {PR && (
                                <Descriptions
                                  size="small"
                                  bordered
                                  className="mb-4"
                                >
                                  <Descriptions.Item
                                    style={{
                                      background: "#FF9900",
                                      color: "#FFFFFF",
                                    }}
                                    label="Status"
                                  >
                                    {PR?.StatusDesc}
                                  </Descriptions.Item>
                                  <Descriptions.Item
                                    className="col-md-3 col-24"
                                    label="Request Date"
                                  >
                                    {moment(PR?.RequestDate).format("LLL")}
                                  </Descriptions.Item>
                                </Descriptions>
                              )}
                            </div>
                            <div className="col-md-12">
                              <Descriptions
                                size="small"
                                bordered
                                className="mb-4"
                              >
                                <Descriptions.Item
                                  label="Total Cost"
                                  className="col-md-3 col-24"
                                >
                                  {`${Math.round(
                                    getTotalDocExtCost()
                                  ).toLocaleString("id-ID")} ${PR.CurrencyCode || ""
                                    }`}
                                </Descriptions.Item>
                                <Descriptions.Item label="Current Dispatcher">
                                  {PR?.CurrDispatcherName ||
                                    PR?.CurrDispatcherID}
                                </Descriptions.Item>
                              </Descriptions>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              {PR && (
                                <>
                                  <Comment
                                    author={
                                      <p>Requestor : {PR.RequestorIDName}</p>
                                    }
                                    content={<p>{PR.CommentText}</p>}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                          <div className="row mt-4">
                            {PR && PR.details?.value.length > 0 && (
                              <div className="col-md-12">
                                <h6
                                  className="mb-1"
                                  style={{
                                    padding: "10px",
                                    borderRadius: 2,
                                  }}
                                >
                                  Details Item
                                </h6>
                                <Table
                                  dataSource={PR.details.value}
                                  className="custom-table"
                                  pagination={{
                                    hideOnSinglePage: true,
                                    showLessItems: true,
                                  }}
                                  style={{ whiteSpace: "nowrap" }}
                                  columns={columnPRDetail}
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mt-4">
                            <div className="col-md-6">
                              {PR && (
                                <>
                                  <Comment
                                    author={<p>Approval Note</p>}
                                    content={<p>{PR.Note}</p>}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </Panel>
                  </Collapse>
                </div>
              </>
            )}
          </div>
          {PR && PR.CurrDispatcherID !== "Purchasing Department" && (
            <div className="row mb-3">
              <div className="col-md-12 text-end">
                <Affix offsetBottom={30}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: 16,
                    }}
                  >
                    <Button
                      type="primary"
                      size="middle"
                      onClick={showModal}
                      style={{ padding: "0 10px" }}
                      disabled={loading}
                    >
                      Submit Decision
                    </Button>
                  </div>
                </Affix>
              </div>
            </div>
          )}
          <Footer></Footer>
        </div>
      </div>
      <Modal
        title="Confirm Approval or Rejection"
        visible={isModalVisible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="Submit"
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ approvalDecision: null, password: "", nextNote: "" }}
        >
          <Form.Item
            name="approvalDecision"
            label="Decision"
            rules={[{ required: true, message: "Select Approve or Reject" }]}
          >
            <Radio.Group>
              <Radio value="approve">Approve</Radio>
              <Radio value="reject">Reject</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="nextNote"
            label="Note / Comment"
            rules={[
              { required: true, message: "Note is Mandatory" },
              { whitespace: true, message: "Note is Mandatory" },
            ]}
          >
            <Input.TextArea rows={4} maxLength={100} placeholder="Note" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ViewEpicorPR;
